<template>
  <div class="contact-module" :class="{ brown: $route.path.includes('/healthcare') }" v-if="contactFormInfo != undefined">

    <!-- Contact Bar -->
    <section class="container-fluid col-xs-12 contact" id="contact" :style="setBackgroundColor(contactFormInfo.background_color.value)">
      <div class="inside row">
        <h2 class="text-center" v-in-viewport="">{{contactFormInfo.headline.value}}</h2>
        <p class="intro_text">{{contactFormInfo.subheadline.value}}</p>
        <button @click="openForm()" class="btn_orange" id="openForm">{{contactFormInfo.button_label.value}}</button>
      </div>
    </section>

    <!-- Contact Us Form -->
    <section id="contactUS" class="section-block  contactUS container-fluid col-xs-12" v-in-viewport="">
      <span class="triangle-top"></span>
      <div class="inner">

        <div class="inside row">
          <div class="col-md-6 col-lg-5 col-md-offset-1 col-lg-offset-2">
            <p class="text-small">* Required fields.</p>
          </div>

          <div class="row form-contact">
            <div class="col-md-6 col-lg-5 col-md-offset-1 col-lg-offset-2">
              <h4 class="title-form col-md-12">EMAIL US</h4>

              <form id="contactForm" @submit.prevent="validateForm('contactForm')" :data-vv-scope="'contactForm'" action="https://webto.salesforce.com/servlet/servlet.WebToLead" method="POST" accept-charset='UTF-8'>
                <!-- Do not remove this code. -->
                <input type=hidden name='captcha_settings' value='{"keyname":"Captcha","fallback":"true","orgId":"00D6A0000038T85","ts":""}'>
                <input type=hidden name="oid" value="00D6A0000038T85" v-model="contactForm.oid">
                <input type=hidden name="retURL" value="http://" v-model="contactForm.retURL">
                <input type=hidden name="Campaign_ID" value="7013u0000007C01AAE" v-model="contactForm.campaign" >
                <input type=hidden name="lead_source" value="Website" v-model="contactForm.lead_source">

                <!-- Do not remove this code. -->
                <div class="form-row">
                  <div class="form-group col-md-6" :class="{error:errors.has('contactForm.first_name')}">
                    <span class="required" v-if="contactForm.first_name === ''">*</span>
                    <input type="text" class="form-control" id="first_name" maxlength='40' name='first_name' placeholder="First Name" v-validate="'required'" v-model="contactForm.first_name">
                    <span class="message-error" v-show="errors.has('contactForm.First Name')" >{{ errors.first('contactForm.first_name') }}</span>
                  </div>
                  <div class="form-group col-md-6" :class="{error:errors.has('contactForm.last_name')}">
                    <span class="required" v-if="contactForm.last_name === ''">*</span>
                    <input type="text" class="form-control"  id="last_name" maxlength='80' name='last_name' placeholder="Last Name" v-validate="'required'" v-model="contactForm.last_name">
                    <span class="message-error" v-show="errors.has('contactForm.Last Name')" >{{ errors.first('contactForm.last_name') }}</span>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-6" :class="{error:errors.has('contactForm.company')}">
                    <span class="required" v-if="contactForm.company === ''">*</span>
                    <input type="text" class="form-control" id="company" maxlength='100' name='company' placeholder="Company" v-validate="'required'" v-model="contactForm.company">
                    <span class="message-error" v-show="errors.has('contactForm.Company')" >{{ errors.first('contactForm.Company') }}</span>
                  </div>
                  <div class="form-group col-md-6" :class="{error:errors.has('contactForm.email')}">
                    <span class="required" v-if="contactForm.email === ''">*</span>
                    <input type="email" class="form-control" id="email" maxlength='100' name='email' placeholder="Email" v-validate="'required|email'" v-model="contactForm.email">
                    <span class="message-error" v-show="errors.has('contactForm.Email')" >{{ errors.first('contactForm.Email') }}</span>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-12" :class="{error:errors.has('contactForm.description')}">
                    <!--<span class="required" v-if="contactForm.description === ''">*</span>-->
                    <textarea id="message" rows="8" cols="80" class="track-it" placeholder="Your message" name='description' maxlength='32000' v-model="contactForm.description"></textarea>
                    <span class="message-error" v-show="errors.has('contactForm.Description')" >{{ errors.first('contactForm.Description') }}</span>
                  </div>
                </div>

                <div class="clearfix"></div>

                <div class="form-row">
                    <div class="form-group col-sm-12">
                      <div class="chiller_cb">
                        <input type="checkbox" class="form-check-input" name="00N3u00000PJKx9" id="00N3u00000PJKx9" value="0" v-model="contactForm.communicationFromMTAccepted"> 
                        <label for="00N3u00000PJKx9" class="lbl-check">Opt-in to communications from Marcus Thomas</label>
                        <span></span>
                      </div>
                    </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-8 ">
                    <vue-recaptcha @verify="markRecaptchaAsVerifiedForm" class="captcha" sitekey="6LfWNoYsAAAAAPb_D9jpoKajSmdXs6WDQx98RUXd"></vue-recaptcha>
                    <div class="captcha-error">
                      <p class="text-small">{{ contactForm.pleaseTickRecaptchaMessage }}</p>
                    </div>
                  </div>
                  <div class="form-group col-md-4 submit-container" >
                    <button type="submit" tag="button" class="btn_orange gtm_buttonCX2_whitepaper_download">Submit</button>
                  </div>
                </div>


              </form>

            </div>

            <div class="col-md-4 col-lg-3"><!-- Right panel -->
              <h4 class="col-md-12 text-center title-form strike"><span>CALL US</span></h4>
              <div class="col-md-12 white-box text-center" v-if="contactFormInfo != undefined">
                <div class="content" v-html="contactFormInfo.right_panel.value">

                </div>
              </div>
            </div>

          </div>

          <div class="row">
            <div v-if="contactForm.formSubmitted" :class="[contactForm.formSubmitted ? 'thank-message fadeIn' : '']">
              <div class="row" v-in-viewport="">
                <div class="col-lg-8 col-lg-offset-2">
                  <p class="text-center">Ok, you’ve taken the first step. We’ll get back to you within one business day.</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

  </div>
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha';
  import FileSaver from 'file-saver/FileSaver';
  import common from '../mixins/common.js';


  export default {
    name:'contactFormformSolutions',
    props: ['contactFormInfo'],
    data () {
      return {
        contactForm: {
          recaptchaVerified: false,
          pleaseTickRecaptchaMessage: '',
          oid:'00D6A0000038T85',
          first_name:'',
          last_name:'',
          company: '',
          email: '',
          description: '',
          campaign: '',
          '00N3u00000PJKx9': false,
          lead_source: 'Website',
          retURL: 'https://mtllc.com/thank-you',
          formSubmitted: false,
          open: false,
        },
      }
    },
    components:{
      VueRecaptcha
    },
    mixins:[common],
    created:function(){
      this.contactForm.campaign = this.contactFormInfo.campaing_id.value;
    },
    methods: {
      webToLead(fields,scope) {
        var customHiddenIframeName='JLA_API';
        if(!document.getElementById(customHiddenIframeName)){
          var theiFrame=document.createElement("iframe");
          theiFrame.id=customHiddenIframeName;
          theiFrame.name=customHiddenIframeName;
          theiFrame.src='about:blank';
          theiFrame.style.display='none';
          document.body.appendChild(theiFrame);
        }
        fields['retURL']='http://127.0.0.1';//dummy URL
        var form = document.createElement("form");
        form.method = "POST";
        form.action = "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8";
        form.setAttribute("target", customHiddenIframeName);
        for (var fieldName in fields) {
          var theInput = document.createElement("input");
          theInput.name=fieldName;
          theInput.value=fields[fieldName];
          theInput.setAttribute("type", "hidden");
          form.appendChild(theInput);
        }
        document.body.appendChild(form);
        form.submit();
        this.contactForm.formSubmitted=true;
        let _this = this;

        setTimeout(function(){
  				_this.resetForm(scope);

  			}, 300);

        setTimeout(function(){
          _this.contactForm.formSubmitted=false;
  			}, 5000);

      },
      openForm() {
        var elem = document.getElementById("contactUS");

        if(this.contactForm.open==false){
          elem.classList.add("opened");
          //elem.maxHeight = elem.getElementsByClassName('inner')[0].offsetHeight + 330;
          document.getElementById('openForm').innerHTML='CLOSE';

          setTimeout(function(){
            if (window.screen.width <= 768) {
              document.getElementById("contactUS").scrollIntoView({block: "start", behavior: "smooth"});
            }
            else {
              document.getElementById("contactUS").scrollIntoView({block: "end", behavior: "smooth"});
            }
            window.onresize = function(event) {
              elem.maxHeight = elem.getElementsByClassName('inner')[0].offsetHeight + 100;
            };
          },300);

        }
        else {
          console.log('s');
          elem.classList.remove("opened");
          elem.maxHeight = elem.getElementsByClassName('inner')[0].offsetHeight + 100;
          document.getElementById('openForm').innerHTML='GET STARTED';

        }

        this.contactForm.open =  !this.contactForm.open;
      },
      markRecaptchaAsVerifiedForm(response) {
        this.contactForm.pleaseTickRecaptchaMessage = '';
        this.contactForm.recaptchaVerified = true;
      },
      resetForm(scope) {
        this.$validator.pause();
        console.log('SF form')

        if(scope=='contactForm'){
          this.contactForm.recaptchaVerified = false;
          this.contactForm.pleaseTickRecaptchaMessage = '';
          this.contactForm.first_name = '';
          this.contactForm.last_name = '';
          this.contactForm.company = '';
          this.contactForm.email = '';
          this.contactForm.description = '';
        }

        this.$validator.errors.clear();
        this.$validator.reset();
        document.getElementById(scope).reset();

      },
      validateForm(scope) {
        console.log(scope);
        //alert(scope);
        this.$validator.resume();
        const dict = {
          custom: {
            email: {
              required: 'This is a required field.',
              email: 'Please enter a validate email address'
            },
            last_name: {
              required: 'This is a required field.',
            },
            first_name: {
              required: 'This is a required field.',
            },
            company: {
              required: 'This is a required field.',
            },
            description: {
              required: 'This is a required field.',
            }
          }
        };
        this.$validator.localize('en', dict);
        this.$validator.validateAll(scope).then((result) => {

          if (result) {
            //Check scope
            var formData = new FormData(document.getElementById(scope));
            var myForm;
            if(scope=='contactForm'){
              myForm = this.contactForm;
              if (!this.contactForm.recaptchaVerified) {
                this.contactForm.pleaseTickRecaptchaMessage = 'Please tick recaptcha.';
                return true; // prevent form from submitting
              }
            }

            this.webToLead({
              //Debug mode
              // debug:1,
              // debugEmail:'psapir@devsutd.com',

              oid                 : myForm.oid,
              first_name          : myForm.first_name,
              last_name           : myForm.last_name,
              email               : myForm.email,
              company             : myForm.company,
              lead_source         : myForm.lead_source,
              Campaign_ID         : myForm.campaign,
              '00N3u00000PJKx9'   : myForm.communicationFromMTAccepted,
              description         : myForm.description
            }, scope);

            return false;

          }
        });
      }
    },
  }
</script>



// WEBPACK FOOTER //
// contact-form-solutions.vue?75f10af5